import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { OnboardingService } from './core/services/onboarding.service.ts.service';

@Injectable({
  providedIn: 'root',
})
export class OnboardingGuard implements CanActivate {
  constructor(
    private onboardingService: OnboardingService,
    private router: Router
  ) {}

  canActivate(route: any): boolean {
    const onboardingData = this.onboardingService.getData();
    const path = route.routeConfig.path; // Ottieni il percorso richiesto

    if (
      path === 'description' &&
      !onboardingData.stepUserInfoCompleted &&
      !onboardingData.stepSelectCompanyCompleted
    ) {
      this.router.navigate(['/']); // Reindirizza alla homepage
      return false;
    }

    if (
      path === 'insert-info' &&
      (!onboardingData.stepSelectCompanyCompleted)
    ) {
      this.router.navigate(['/']); // Reindirizza alla homepage
      return false;
    }

    return true; // Accesso consentito
  }
}